;
import { Layout } from "../../../layout/index";
import SearchPage from "../components/SearchPage";

export function DeepSearch() {
  return (
<div>
  <Layout>

<SearchPage />
  </Layout>

</div>

  );
}